export default (): void => {
  const buttonEl = document.querySelector<HTMLButtonElement>('[aria-controls="product-summary-reviews-summary-review-more"]')
  const contentEl = document.getElementById('product-summary-reviews-summary-review-more') as HTMLElement

  if (!buttonEl || !contentEl) {
    return
  }

  buttonEl.addEventListener('click', () => {
    buttonEl.remove()
    contentEl.removeAttribute('hidden')
  })
}
